import React from "react";
import {useViewerStore} from "../../../../store/store";

const Addressbar: React.FC = () => {

    const siteAddress: string = useViewerStore(state => state.siteAddress);

    return (
        <div id={"siteAddressLabel"}>{siteAddress}</div>
    )
}

export default Addressbar;